import React from 'react';

// The portal's one on/off switch, as pixels: the track's fill and the dot that
// slides along it. Two controls draw a switch — the rjsf boolean widget
// (CustomCheckbox, a headless-ui Switch) and the action sections'
// ScheduleToggle (a plain button with role="switch") — and both take their
// look from here so they cannot drift apart.
//
// The look is the EarthRanger spec sheet's (allenai/design.md, spec-sheet.html):
// a 44x24 track with a 20px dot (the spec's 34x18 and 14px, scaled up). Off is
// a white track with a Teal T80 line and dot; on is a Teal T100 track with a
// white dot.
//
// Geometry lives in routeDetailsClasses.switchContainer.
export const switchTrackFill = (on: boolean) =>
  on
    ? 'border-teal-t100 bg-teal-t100 focus:ring-teal-t100/35'
    : 'border-teal-t80 bg-white focus:ring-teal-t80/35';

// Everything inside the track. The parent supplies the track itself, because one
// caller needs a headless-ui <Switch> and the other a <span> inside its button.
const SwitchVisual = ({ on }: { on: boolean }) => (
  <span
    aria-hidden="true"
    className={`pointer-events-none inline-block size-5 rounded-full transition-transform duration-200 ease-in-out ${on ? 'translate-x-5 bg-white' : 'translate-x-0 bg-teal-t80'}`}
  />
);

export default SwitchVisual;
